// src/api/projectCreationApi.js
import axios from 'axios';

const BASE_URL = "https://ims.holdthechild.net/api";
// const BASE_URL = "http://localhost:3100/api"; // Uncomment for local development


export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  };
};


export const fetchProjects = async () => {
  const res = await axios.get(`${BASE_URL}/projects`, {
    headers: getAuthHeaders(),
  });
  return res.data.data;
};

export const createProject = async (projectData) => {
  const res = await axios.post(`${BASE_URL}/projects`, projectData, {
    headers: getAuthHeaders(),
  });
  return res.data.data;
};

export const fetchDonors = async () => {
  const res = await axios.get(`${BASE_URL}/donors`, {
    headers: getAuthHeaders(),
  });
  return res.data.data;
};

//  NEW FUNCTION: This function was missing 
export const updateProject = async (projectId, projectData) => {
  const res = await axios.put(`${BASE_URL}/projects/${projectId}`, projectData, {
    headers: getAuthHeaders(),
  });
  return res.data.data;
};

// NEW FUNCTION: Fetches the aggregated project statistics
export const fetchProjectStats = async () => {
  const res = await axios.get(`${BASE_URL}/projects/stats/summary`, {
    headers: getAuthHeaders(),
  });
  return res.data.data;
};

// NEW FUNCTION: Fetches all staff with the program_manager role
export const fetchProgramManagers = async () => {
  const res = await axios.get(`${BASE_URL}/staff/program-managers`, {
    headers: getAuthHeaders(),
  });
  return res.data.data;
};
// In src/api/projectCreationApi.js// or the correct path to your timesheet API
